import React, { useState } from 'react'; // Asegúrate de importar React
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Switch from '@mui/material/Switch';

// Otis Kit PRO components
import MKBox from 'components/MKBox';
import MKInput from 'components/MKInput';
import MKButton from 'components/MKButton';
import MKTypography from 'components/MKTypography';

// Importar el componente PrivacyPolicy

// Map
import GoogleMap from 'layouts/sections/Maps/googleMaps';
import PrivacyPolicy from './politica';
import { useDispatch, useSelector } from 'react-redux';
import { sendContactRequest } from '../../../../../../redux/actions';

function ContactUsnew() {
  const dispatch = useDispatch();
  // eslint-disable-next-line prettier/prettier, no-unused-vars
  const { loading, error, message } = useSelector(state => state.contact);

  const [form, setForm] = useState({
    nombre: '',
    apellido: '',
    correo: '',
    mensaje: '',
    intereses: [],
  });

  const [openPrivacy, setOpenPrivacy] = useState(false); // Estado para controlar el modal
  const [isAccepted, setIsAccepted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleInteresChange = (event, newValue) => {
    setForm({ ...form, intereses: newValue });
  };
  const handleSwitchChange = (event) => {
    setIsAccepted(event.target.checked);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isAccepted) {
      const nombreCompleto = `${form.nombre} ${form.apellido}`;
      const mensajeCompleto = `${form.mensaje}/Intereses: ${form.intereses.join(',')}`;
      const dataToSend = {
        fullName: nombreCompleto,
        email: form.correo,
        subject: 'Formulario de contacto web',
        message: mensajeCompleto,
      };
      dispatch(sendContactRequest(dataToSend));
    } else {
      alert('Debes aceptar el política de privacidad para poder enviar tu mensaje');
    }
  };

  // Función para cambiar el estado del switch
  // const handleSwitchChange = (event) => {
  //   setIsAccepted(event.target.checked);
  // };

  return (
    <MKBox component="section" id="contact-us" py={{ xs: 0, lg: 0 }}>
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MKBox
              component="form"
              onSubmit={handleSubmit}
              width="100%"
              bgColor="white"
              borderRadius="xl"
              shadow="xl"
              mb={6}
              sx={{ overflow: 'hidden' }}
            >
              <Grid container spacing={0} sx={{ minHeight: 'auto' }}>
                {/* Formulario */}
                <Grid item xs={12} md={7}>
                  <MKBox
                    p={3}
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                    }}
                    data-aos="fade-up"
                    data-aos-duration="1000"
                    data-aos-offset="200"
                  >
                    <MKBox px={{ xs: 2, sm: 3 }} py={{ xs: 2, sm: 6 }}>
                      <MKTypography
                        variant="h3"
                        mb={1}
                        sx={{
                          color: '#1976d2',
                          fontSize: { xs: '1.5rem', sm: '2rem', lg: '2.5rem' },
                          textAlign: { xs: 'center', md: 'left' },
                        }}
                      >
                        CONTÁCTANOS
                      </MKTypography>
                    </MKBox>
                    <MKBox pt={0.5} pb={3} px={{ xs: 2, sm: 3 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <MKInput
                            variant="standard"
                            label="Nombre"
                            name="nombre"
                            value={form.nombre}
                            onChange={handleChange}
                            // InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <MKInput
                            variant="standard"
                            label="Apellido"
                            name="apellido"
                            value={form.apellido}
                            onChange={handleChange}
                            // InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <MKInput
                            variant="standard"
                            label="Correo"
                            name="correo"
                            value={form.correo}
                            onChange={handleChange}
                            // InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <MKInput
                            variant="standard"
                            label="Celular"
                            // InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Autocomplete
                            multiple
                            freeSolo
                            value={form.intereses}
                            onChange={handleInteresChange}
                            options={[
                              'Moviint',
                              'Scout',
                              'Mi taller',
                              'Outsourcing',
                              'Consultoria',
                              'Diseño y desarrollo',
                            ]}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label="Tengo interés en:"
                                // placeholder="Selecciona o escribe un mensaje"
                                InputLabelProps={{ shrink: true }}
                              />
                            )}
                            sx={{
                              '& .MuiInputBase-root': {
                                fontSize: '0.9rem',
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <MKInput
                            variant="standard"
                            label="Mensaje"
                            name="mensaje"
                            value={form.mensaje}
                            onChange={handleChange}
                            fullWidth
                            multiline
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} display="flex" alignItems="center">
                          <MKTypography variant="body2" color="text" sx={{ marginRight: 1 }}>
                            Acepto la
                          </MKTypography>
                          <span
                            onClick={() => setOpenPrivacy(true)}
                            style={{
                              cursor: 'pointer',
                              textDecoration: 'underline',
                              color: '#1976d2', // Color normal
                              fontSize: '0.875rem',
                            }}
                          >
                            Política de privacidad
                          </span>
                          <Switch
                            checked={isAccepted}
                            onChange={handleSwitchChange}
                            inputProps={{ 'aria-label': 'Aceptar política de privacidad' }}
                            sx={{ marginLeft: '10px' }}
                          />
                        </Grid>
                        <Grid item xs={12} display="flex" justifyContent="flex-end">
                          <MKButton variant="contained" type="submit" disabled={loading}>
                            Enviar
                          </MKButton>
                        </Grid>
                      </Grid>
                    </MKBox>
                  </MKBox>
                </Grid>

                {/* Mapa en lugar de la imagen */}
                <Grid
                  item
                  xs={12}
                  md={5}
                  position="relative"
                  px={0}
                  sx={{ height: { xs: '500px', md: 'auto' } }}
                >
                  <MKBox width="100%" height="100%" position="relative" zIndex={2}>
                    <GoogleMap />
                  </MKBox>
                </Grid>
              </Grid>
            </MKBox>
          </Grid>
        </Grid>
      </Container>

      {/* Modal de política de privacidad */}
      <Dialog open={openPrivacy} onClose={() => setOpenPrivacy(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          Política de Privacidad
          <IconButton
            aria-label="close"
            onClick={() => setOpenPrivacy(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {/* Aquí se muestra la política de privacidad */}
          <PrivacyPolicy />
        </DialogContent>
      </Dialog>
    </MKBox>
  );
}

export default ContactUsnew;
